import React from 'react';
import { Trophy } from "lucide-react";

interface BadgePreviewProps {
  badgeUrl: string;
}

export const BadgePreview = ({ badgeUrl }: BadgePreviewProps) => {
  console.log('BadgePreview rendering with URL:', badgeUrl);
  
  return (
    <div className="block max-w-[300px] no-underline transition-transform hover:scale-[1.02]">
      <div className="bg-gradient-to-br from-[#174996] to-[#0d2b59] rounded-xl p-5 text-white shadow-lg border-2 border-white/10">
        <div className="flex items-center gap-2">
          <Trophy className="h-5 w-5 text-yellow-300" />
          <div className="text-sm font-medium tracking-wide">Trusted by Home Pros OKC</div>
        </div>
      </div>
    </div>
  );
};